import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface UploadKaroakeResponse extends APIResponse
{

}

export class UploadKaroakeResponseDtoImpl extends APIResponseDtoImpl implements UploadKaroakeResponse
{
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/karoake/uploadkaroake/uploadkaroakeresponse.tsx